module.exports = __webpack_public_path__ + "media/images/flags/1x1/mdg-5d613701ab14c98617fe48d301bee6b6.svg";